module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stepFour"
  }, [_c('headers'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('steps', {
    attrs: {
      "step-num": 3
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "stepFour-content"
  }, [_c('Icon', {
    attrs: {
      "type": "md-checkmark-circle"
    }
  }), _vm._v(" "), _c('p', [_vm._v("激活成功，5秒后返回登录！"), _c('a', {
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v("登录")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e77d56d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pc/stepFour.vue
// module id = 198
// module chunks = 0